module.exports = __webpack_public_path__ + "static/dg-5-61fbc77522c4cc9d59be1a407579a466.png";